import { useSearchParams } from 'react-router-dom';
import React from 'react';

let jwtToken: string;

export const useAuthorizeEmbeddedDashboardUser = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [authResult, setAuthResult] = React.useState(false);

  const accessCode = searchParams.get('access_code');
  React.useEffect(() => {
    if (accessCode) {
      searchParams.delete('access_code');
      setSearchParams(searchParams);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      jwtToken = window.embeddedUserToken;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.embeddedUserToken = undefined;
      setAuthResult(true);
    }
  }, [accessCode]);

  return authResult;
};

export const getJwtToken = () => jwtToken;
